/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TemplateGetParamsRequest {
    getFixupPrototypeFunction() { return TemplateGetParamsRequest.fixupPrototype; }

    static newInstance(model: Partial<TemplateGetParamsRequest>): TemplateGetParamsRequest {
        let obj = Object.assign(new TemplateGetParamsRequest(), model);
        TemplateGetParamsRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TemplateGetParamsRequest>): TemplateGetParamsRequest {
        if (!model) return null;
        return TemplateGetParamsRequest.newInstance(<TemplateGetParamsRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TemplateGetParamsRequest) {
        if (!obj) return;

        models.TemplateGetParamsRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TemplateGetParamsRequest): boolean {
        Object.setPrototypeOf(obj, TemplateGetParamsRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.cloud_accounts) {
            for (let val of this.cloud_accounts) {
                models.CloudAccount.fixupPrototype(val);
            }
        }
    }

    /**
     * cloud account details to execute the template
     */
    cloud_accounts: Array<models.CloudAccount>;

}
